// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_String from "@rescript/runtime/lib/es6/Stdlib_String.js";

function fromBody(body, limitOpt) {
  let limit = limitOpt !== undefined ? limitOpt : 180;
  let compact = body.replaceAll("\n", " ").trim();
  if (compact.length <= limit) {
    return compact;
  }
  let cut = compact.slice(0, limit);
  let index = Stdlib_String.lastIndexOfOpt(cut, " ");
  if (index !== undefined) {
    return cut.slice(0, index) + "…";
  } else {
    return cut + "…";
  }
}

function paragraphs(body) {
  return body.split("\n").map(prim => prim.trim()).filter(part => part !== "");
}

export {
  fromBody,
  paragraphs,
}
/* No side effect */
